import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QuoteProvider } from './QuoteContext';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import App from './App';

const AppWithProviders = () => {
  return (
    <BrowserRouter>
      <QuoteProvider>
        <TooltipProvider>
          <App />
        </TooltipProvider>
      </QuoteProvider>
    </BrowserRouter>
  );
};

export default AppWithProviders;
